import { render } from "./EditPersonalInfo.vue?vue&type=template&id=7101e988"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\如峰\\浮雲客棧webapp 前後台系統\\前台\\kloudmobileweb\\KloudMobileWeb\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBar,QBtn,QForm,QInput});
